export default {
  // ===== 用户管理 (global/users/index.tsx) =====
  'global.users.cardTitle': '用户管理',
  'global.users.refreshButton': '刷新',
  'global.users.searchPlaceholder': '搜索邮箱、昵称或手机号',
  'global.users.statusFilter': '状态筛选',
  'global.users.roleFilter': '角色筛选',
  'global.users.searchButton': '查询',
  'global.users.tableTotal': '共 {total} 个用户',

  'global.users.column.user': '用户',
  'global.users.column.email': '邮箱',
  'global.users.column.phone': '手机号',
  'global.users.column.realName': '真实姓名',
  'global.users.column.deptName': '部门',
  'global.users.column.positionName': '职位',
  'global.users.column.roles': '角色',
  'global.users.column.status': '状态',
  'global.users.column.lastLogin': '最近操作',
  'global.users.column.actions': '操作',
  'global.users.column.tenantName': '租户',

  'global.users.action.detail': '详情',
  'global.users.action.role': '角色',
  'global.users.action.unban': '解封',
  'global.users.action.ban': '封禁',

  'global.users.banConfirm': '确定要封禁该用户吗？',
  'global.users.unbanConfirm': '确定要解封该用户吗？',

  'global.users.status.active': '正常',
  'global.users.status.disabled': '禁用',
  'global.users.status.locked': '锁定',
  'global.users.status.banned': '封禁',

  'global.users.loadFailed': '加载失败',
  'global.users.loadListFailed': '加载用户列表失败',
  'global.users.getDetailFailed': '获取详情失败',
  'global.users.getUserDetailFailed': '获取用户详情失败',
  'global.users.roleUpdateSuccess': '角色更新成功',
  'global.users.updateFailed': '更新失败',
  'global.users.roleUpdateFailed': '角色更新失败',
  'global.users.userBanned': '用户已封禁',
  'global.users.userUnbanned': '用户已解封',
  'global.users.operationFailed': '操作失败',
  'global.users.statusUpdateFailed': '状态更新失败',

  'global.users.stats.total': '总用户数',
  'global.users.stats.active': '活跃用户',
  'global.users.stats.verified': '已验证',
  'global.users.stats.banned': '已封禁',
  'global.users.stats.todayNew': '今日新增',
  'global.users.stats.todayActive': '今日活跃',

  'global.users.detailModal.title': '用户详情',
  'global.users.detail.id': 'ID',
  'global.users.detail.nickname': '昵称',
  'global.users.detail.email': '邮箱',
  'global.users.detail.emailVerified': '已验证',
  'global.users.detail.emailNotVerified': '未验证',
  'global.users.detail.phone': '手机号',
  'global.users.detail.status': '状态',
  'global.users.detail.roles': '角色',
  'global.users.detail.loginMethods': '登录方式',
  'global.users.detail.referralCode': '推荐码',
  'global.users.detail.lastLogin': '最近操作',
  'global.users.detail.createdAt': '注册时间',
  'global.users.detail.google': 'Google',
  'global.users.detail.oaProfiles': 'OA 档案',
  'global.users.detail.tenantCount': '{count} 个租户',

  'global.users.rolesModal.title': '编辑角色 - {name}',
  'global.users.rolesModal.operationLabel': '操作类型',
  'global.users.rolesModal.operationRequired': '请选择操作类型',
  'global.users.rolesModal.opReplace': '替换（覆盖现有角色）',
  'global.users.rolesModal.opAssign': '添加角色',
  'global.users.rolesModal.opRemove': '移除角色',
  'global.users.rolesModal.rolesLabel': '角色列表',
  'global.users.rolesModal.rolesRequired': '请选择至少一个角色',
  'global.users.rolesModal.rolesPlaceholder': '选择角色',
};
